export default "__VITE_ASSET__COTpjeMi__"